import Vue from 'vue';
import utils from './utils';
import alerts from './alerts';

Vue.use(utils);
Vue.use(alerts);
